import { createContext } from "react";

type ErrorContextType = {
  setError: (error: Error) => void;
};

export type Error = {
  title: string;
  message: string;
};

export const ErrorContext = createContext<ErrorContextType>({
  setError: () => {},
});
